import React from 'react';

export const activeBodyTemplate = (rowData) => {
    const active = rowData.isActive;
    return <span className={`badge border-0 font-semibold text-xs ${active ? 'bg-success/10 text-success' : 'bg-error/10 text-error'}`}>{active ? 'Active' : 'Inactive'}</span>;
};

export const lockedBodyTemplate = (rowData) => {
    const locked = rowData.locked || rowData.isLocked;
    return <span className={`badge border-0 font-semibold text-xs ${locked ? 'bg-error/10 text-error' : 'bg-success/10 text-success'}`}>{locked ? 'Locked' : 'Unlocked'}</span>;
};

export const formatDateTime = (value) => {
    if (!value) return '-';
    try {
        return new Date(value).toLocaleString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    } catch (e) {
        return value;
    }
};

// Returns a Column `body` renderer that shows `rowData[field]` as a readable date and time.
export const dateTimeBody = (field) => (rowData) => formatDateTime(rowData[field]);

export const amountBodyTemplate = (rowData) => Number.parseFloat(rowData.amount || 0).toFixed(2);

const STATUS_TONES = {
    pending: 'bg-warning/10 text-warning',
    success: 'bg-success/10 text-success',
    failure: 'bg-error/10 text-error',
    processing: 'bg-info/10 text-info',
};

const classifyPaymentStatus = (upperStatus, extraSuccess) => {
    if (upperStatus === 'PENDING') return STATUS_TONES.pending;
    if (['SUCCESS', 'COMPLETED', 'SUCCESSFUL'].includes(upperStatus) || extraSuccess?.(upperStatus)) return STATUS_TONES.success;
    if (upperStatus === 'FAILED' || upperStatus === 'DECLINED') return STATUS_TONES.failure;
    if (upperStatus === 'PROCESSING') return STATUS_TONES.processing;
    return 'bg-base-200/50 text-base-content';
};

// Builds the payment-status badge renderer. `extraSuccess(upperStatus)` can mark more statuses as successful.
export const createPaymentStatusTemplate = (extraSuccess) => (rowData) => {
    const status = rowData.paymentStatus;
    if (!status) {
        return <span className="badge border-0 font-semibold text-xs bg-base-200/50 text-base-content">-</span>;
    }
    return <span className={`badge border-0 font-semibold text-xs ${classifyPaymentStatus(status.toUpperCase(), extraSuccess)}`}>{status}</span>;
};

export const paymentStatusBodyTemplate = createPaymentStatusTemplate();

// POS/agent reports also treat bank response codes (NMB..., CR...) as successful.
export const bankPaymentStatusBodyTemplate = createPaymentStatusTemplate(
    (upperStatus) => upperStatus.includes('NMB') || upperStatus.includes('CR')
);

export const createPaymentMethodTemplate = (className = '') => (rowData) => {
    const method = rowData.paymentMethod;
    if (!method) return null;
    return <span className={`badge badge-outline font-semibold text-xs badge-ghost ${className}`.trim()}>{method}</span>;
};

export const paymentMethodBodyTemplate = createPaymentMethodTemplate();

export const easipolStatusBodyTemplate = (rowData) => {
    const status = rowData.easipolPaymentResponse;
    if (!status) return <span className="badge badge-outline font-semibold text-xs badge-ghost">-</span>;
    const upperStatus = String(status).toUpperCase();
    let color = 'badge-ghost';
    if (upperStatus === 'PENDING') {
        color = 'badge-warning';
    } else if (upperStatus.includes('SUCCESS') || upperStatus === 'COMPLETED') {
        color = 'badge-success';
    } else if (upperStatus.includes('FAIL') || upperStatus === 'DECLINED' || upperStatus.includes('ERROR')) {
        color = 'badge-error';
    } else if (upperStatus === 'PROCESSING') {
        color = 'badge-info';
    }
    return <span className={`badge badge-outline font-semibold text-xs ${color}`}>{status}</span>;
};
